import { client } from '../../core/Amplify/appsyncClient';
import { getOngoingCallsPaged } from '../../graphql/queries';
import { onOngoingCalls } from '../../graphql/subscriptions';
import { triggerOngoingCallsUpdate } from '../../graphql/mutations';

import type { GraphQLResult, GraphQLSubscription } from 'aws-amplify/api';
import type {
  GetOngoingCallsPagedQuery,
  GetOngoingCallsPagedQueryVariables,
  OnOngoingCallsSubscription,
  OngoingCallsResponse,
  TriggerOngoingCallsUpdateMutation,
} from '../../models/amplify/API';

type FetchOpts = Partial<GetOngoingCallsPagedQueryVariables>;

export async function fetchOngoingCalls(opts: FetchOpts = {}) {
  const variables: GetOngoingCallsPagedQueryVariables = {
    page: opts.page ?? 1,     
    pageSize: opts.pageSize ?? 10,
    filter: opts.filter,
    sortDirection: opts.sortDirection,
  };

  const res = (await client.graphql<GetOngoingCallsPagedQuery>({
    query: getOngoingCallsPaged,
    variables,
  })) as GraphQLResult<GetOngoingCallsPagedQuery>;

  const data = res.data?.getOngoingCallsPaged;
  const empty: OngoingCallsResponse = { __typename: "OngoingCallsResponse", opi: [], vri: [] };
  if (!data) return empty;

  return {
    __typename: data.__typename ?? "OngoingCallsResponse",
    opi: data.opi ?? [],
    vri: data.vri ?? [],
  } as OngoingCallsResponse;
}

export async function triggerOngoingCalls() {
  const res = (await client.graphql<TriggerOngoingCallsUpdateMutation>({
    query: triggerOngoingCallsUpdate,
  })) as GraphQLResult<TriggerOngoingCallsUpdateMutation>;
  return res.data?.triggerOngoingCallsUpdate ?? [];
}

export function subscribeOngoingCalls(
  next: (evt: { data?: OnOngoingCallsSubscription }) => void,
  error?: (err: unknown) => void
) {
  const sub = client
    .graphql<GraphQLSubscription<OnOngoingCallsSubscription>>({
      query: onOngoingCalls,
    })
    .subscribe({ next, error });

  return () => sub.unsubscribe();
}
